import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
  height: fit-content;
  width: 100%;
  ${media.mobile`
    padding-bottom: 25px;
  `};
`;

export const PageHeaderTitle = styled.h1`
  font-size: 40px;
  color: ${colors.BLACK_RUSSIAN};
  font-weight: 500;
  margin-bottom: 32px;
  ${media.mobile`
    font-size: 24px;
  `};
`;

export const PageHeaderDetails = styled.p`
  font-size: 18px;
  color: ${colors.MED_DARK_GRAY};
  margin-bottom: 16px;
`;
